<style lang="less" scoped>
.abs-tcenter { position: absolute; top: 50%; transform: translate(0,-50%); }

.filter-date-container{
  >div {
    margin-left: 5px;
    vertical-align: middle;
  }

  .btn-excel-down {
    position: relative;
    border: 1px solid #dde1e3;
    line-height: 34px;
    display: inline-block;
    border-radius: 3px;
    margin-left: 5px;
    vertical-align: middle;
    color: #2d7c31;
    padding: 0 13px 0 33px;
    &:hover {
      background-color: #f4fff5;
    }
    &::before {
      content: '';
      .abs-tcenter;
      left: 12px;
      margin-top: 1px;
      background-image: url(~@/assets/icon-excel.png);
      background-size: cover;
      width: 14px;
      height: 16px;
    }
  }
}
</style>

<template lang="pug">
  .filter-date-container
    el-select.md.white(v-if="hasDevice", :value="device", @change="changeDevice", placeholder="전체", class="s-input", style="width: 90px")
      el-option(label="전체", value="")
      el-option(label="모바일", value="M")
      el-option(label="PC", value="P")
    el-date-picker(
      v-if="type === 'range'",
      v-model="dateRangeVal",
      type="daterange",
      align="right",
      range-separator="~",
      format="yy.MM.dd",
      class="s-input c-datepicker",
      style="width: 200px",
      @change="changeDate",
      :editable="false",
      :clearable="false",
      :picker-options="pickerOptions",
    )
    el-date-picker(
      v-if="type === 'day'",
      v-model="dateVal",
      format="yy.MM.dd",
      value-format="yy-MM-dd",
      class="s-input c-datepicker",
      style="width: 200px",
      @change="changeDate",
      :editable="false",
      :clearable="false",
      :picker-options="pickerOptions2",
    )
    //- el-popover(
    //-   placement="top",
    //-   width="160",
    //-   v-model="visible"
    //- )
    //-   p 정말 다운로드 하시겠습니까?
    //-   div(style="text-align: right; margin: 0")
    //-     el-button(size="mini", type="text", @click="visible = false") 아니요
    //-     el-button(size="mini", type="primary", @click="visible = false") 네
    //-   el-button.btn-excel-down(slot="reference") 엑셀 다운로드
    el-button.btn-excel-down(size="mini", :loading="download" @click="excelDownload") 엑셀 다운로드
    a(:download="downloadName", :href="downloadUrl", @click="clearDownload", ref="downBtn")
</template>

<script>
import moment from 'moment';

export default {
  props: {
    type: {
      type: String,
      default: 'range',
    },
    hasDevice: {
      type: Boolean,
      default: false,
    },
    device: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: moment().format('YY-MM-DD'),
    },
    dateFilter: {
      type: String,
      default: '',
    },
    dateRange: {
      type: Array,
      default: () => ([
        moment().subtract(3, 'month'),
        moment(),
      ]),
    },
    downloadName: {
      type: String,
      default: null,
    },
    downloadUrl: {
      type: String,
      default: null,
    },
    download: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    changeDevice(value) {
      console.log(value);
      this.$emit('changeDevice', value);
    },
    changeDate(value) {
      console.log(value);
      this.$emit('changeDate', value);
    },
    excelDownload() {
      this.$emit('excelDownload');
    },
    clearDownload() {
      this.$emit('clearDownload');
    },
  },

  watch: {
    dateRange(value) {
      this.dateRangeVal = value;
    },
    date(value) {
      this.dateVal = value;
    },
    download(value) {
      if (value === true) {
        setTimeout(() => {
          this.$refs.downBtn.click();
        }, 1000);
      }
    },
  },

  mounted() {
    if (this.type !== 'day') {
      this.dateRangeVal = this.dateRange;
    } else {
      this.dateVal = this.date;
    }
  },

  data() {
    return {
      visible: false,
      dateVal: moment().format('YY-MM-DD'),
      dateRangeVal: [
        moment().subtract(3, 'month'),
        moment(),
      ],
      pickerOptions: {
        shortcuts: [{
          text: '최근 7일',
          onClick(picker) {
            picker.$emit('pick', [moment().subtract(6, 'day'), moment()]);
          },
        }, {
          text: '최근 1달',
          onClick(picker) {
            picker.$emit('pick', [moment().subtract(1, 'month'), moment()]);
          },
        }, {
          text: '최근 3달',
          onClick(picker) {
            picker.$emit('pick', [moment().subtract(3, 'month'), moment()]);
          },
        }, {
          text: '최근 6달',
          onClick(picker) {
            picker.$emit('pick', [moment().subtract(6, 'month'), moment()]);
          },
        }],
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
};
</script>
